// openapi-fetch wrapper with cookie + CSRF injection (per w1.md §4.8 + ADR-0008).
//
// **Typed against the generated contract** (W46.0). This file used to say
// 「types not yet generated from backend openapi.yaml … replace once
// `src/types/api.ts` exists」 and to be `createClient<any>` — while
// `src/types/api.ts` had existed for a long time at ~336 KB. The comment was
// the tell: a reader had no way to know whether the type pipeline was wired.
//
// It is now `createClient<paths>`, so `api.GET("/api/v1/diaries")` is checked
// against `docsnew/11-api/openapi.yaml` at compile time — the contract in
// `architecture.md §9` and the one `pnpm dev:check-schema` compares against the
// running backend are now the *same* contract, enforced twice instead of
// documented once.
//
// The `lib/api/*` wrappers still cast through `AnyClient` (each has its own
// per-module `call<T>` shape). That is deliberate and incremental: they are
// being migrated onto `components["schemas"][...]` one response type at a time,
// because swapping all of them in one pass is a type-error hunt rather than a
// change. A new wrapper should NOT copy the old pattern.

import createClient, { type Middleware } from "openapi-fetch";

import type { paths } from "@/types/api";
import { getCsrfToken } from "./csrf";

const CSRF_HEADER_NAME = import.meta.env.VITE_CSRF_HEADER_NAME ?? "X-CSRF-Token";

// Cookie-inject + CSRF middleware. All requests go through this so:
//   - credentials: "include" is set (session cookie sent automatically)
//   - CSRF header is added on mutating verbs (POST / PUT / DELETE / PATCH)
const middleware: Middleware = {
  async onRequest({ request }) {
    request.headers.set("Accept", "application/json");
    const csrf = getCsrfToken();
    if (csrf && /^(POST|PUT|DELETE|PATCH)$/.test(request.method)) {
      request.headers.set(CSRF_HEADER_NAME, csrf);
    }
    return request;
  },
};

export const api = createClient<paths>({
  baseUrl: "/", // Vite dev proxy handles /api/* forwarding
  credentials: "include",
});

// Apply middleware (openapi-fetch exposes `use`).
api.use(middleware);
